import { render, staticRenderFns } from "./SelectGroup.vue?vue&type=template&id=24ca5d18&scoped=true"
import script from "./SelectGroup.vue?vue&type=script&lang=ts"
export * from "./SelectGroup.vue?vue&type=script&lang=ts"
import style0 from "./SelectGroup.vue?vue&type=style&index=0&id=24ca5d18&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24ca5d18",
  null
  
)

export default component.exports